module.exports = require('./dist/lib/error')



//////////////////
// WEBPACK FOOTER
// ../node_modules/next/error.js
// module id = 1030
// module chunks = 29